import {
  ADD_STEP_TO_CURRENT_DT_PATH,
  FINISH_DECISION_TREE,
  IS_CHECK_UP_AVAILABLE_FOR_CURRENT_DIAGNOSIS_TREE,
  PREPARE_NEW_DECISION_TREE_SERVICE,
  REMOVE_STEP_FROM_CURRENT_DT_PATH,
  RESTORE_LAST_CC_DECISION_TREE,
  UPDATE_CHECK_UP_SERVICES,
  UPDATE_DECISION_TREE_SERVICES,
} from './types';
import { createAction, getActionList } from './action-utils';
import { StateType } from 'ts/types';

const actions = {
  addStepToCurrentDTPath: ({
    id,
    value,
    questionText,
    answerText,
  }: {
    [_: string]: any;
  }) =>
    createAction(ADD_STEP_TO_CURRENT_DT_PATH, {
      id,
      value,
      questionText,
      answerText,
    }),
  finishDecisionTree: () => createAction(FINISH_DECISION_TREE, {}),
  isCheckUpAvailableForCurrentDiagnosisPath: () =>
    createAction(IS_CHECK_UP_AVAILABLE_FOR_CURRENT_DIAGNOSIS_TREE, {}),
  removeStepFromCurrentDTPath: () =>
    createAction(REMOVE_STEP_FROM_CURRENT_DT_PATH, {}),
  restoreLastDecisionTree: () =>
    createAction(RESTORE_LAST_CC_DECISION_TREE, {}),
  updateCheckUpService: ({ service }: { service: string }) =>
    createAction(UPDATE_CHECK_UP_SERVICES, {
      service,
    }),
  updateDecisionTreeServices: ({
    interventionObjectsContext,
    services,
    result,
  }: {
    interventionObjectsContext: StateType[];
    services: string[];
    result: any;
  }) =>
    createAction(UPDATE_DECISION_TREE_SERVICES, {
      interventionObjectsContext,
      services,
      result,
    }),
  prepareNewDecisionTreeService: ({
    service,
    questions,
  }: {
    service: string;
    questions: any[];
  }) =>
    createAction(PREPARE_NEW_DECISION_TREE_SERVICE, {
      service,
      questions,
    }),
};

export default actions;

const actionList = getActionList(actions);

export type LocalDecisionTreeActionType = typeof actionList[number];
